import {
    FETCH_UNREAD_START,
    FETCH_UNREAD_SUCCESS,
    FETCH_UNREAD_ERROR,

    FETCH_CONVERSATION_START,
    FETCH_CONVERSATION_SUCCESS,
    FETCH_CONVERSATION_ERROR,

    SEND_MESSAGE_START,
    SEND_MESSAGE_SUCCESS,
    SEND_MESSAGE_ERROR,

    FETCH_BLOCKED_USERS_START,
    FETCH_BLOCKED_USERS_SUCCESS,
    FETCH_BLOCKED_USERS_ERROR,

    UPDATE_MESSAGE_START,
    UPDATE_MESSAGE_SUCCESS,
    UPDATE_MESSAGE_ERROR,

    FETCH_MEMBERS_IN_SCOPE_START,
    FETCH_MEMBERS_IN_SCOPE_SUCCESS,
    FETCH_MEMBERS_IN_SCOPE_ERROR,

    FETCH_MESSAGE_START,
    FETCH_MESSAGE_SUCCESS,
    FETCH_MESSAGE_ERROR,

    FETCH_REPORT_START,
    FETCH_REPORT_SUCCESS,
    FETCH_REPORT_ERROR,
} from './messageActions';

import {
  AUTH_LOGOUT_SUCCESS
} from '../parts/session/sessionActions';

const initialState = {
    unreadNumber: 0,
    selectedConversation: { results: {} },
    conversationFetchTime: undefined,
    blockedUsers: [],
    selectedRecipients: [],
    message: {},
    report: {},

    isFetchUnreadInProgress: false,
    isFetchConversationInProgress: false,
    isFetchBlockedUsersInProgress: false,
    isSendMessageInProgress: false,
    isUpdateMessageInProgress: false,
    isFetchMembersInScopeInProgress: false,
    isFetchMessageInProgress: false,
    isFetchReportInProgress: false,
}

export default function messageReducer(state = initialState, action) {
    switch (action.type) {
        case AUTH_LOGOUT_SUCCESS:
            return {
                ...initialState,
                ...state
            }

        case FETCH_UNREAD_START:
            return {
                ...state,
                isFetchUnreadInProgress: true
            };
        case FETCH_UNREAD_SUCCESS:
            return {
                ...state,
                isFetchUnreadInProgress: false,
                unreadNumber: action.payload
            };
        case FETCH_UNREAD_ERROR:
            return {
                ...state,
                isFetchUnreadInProgress: false,
                unreadNumber: initialState.unreadNumber
            };
        
        case FETCH_CONVERSATION_START:
            return {
                ...state,
                isFetchConversationInProgress: true
            };
        case FETCH_CONVERSATION_SUCCESS:
            let conv = action.payload;
            let prevConv = state.selectedConversation
            let newConv = undefined

            if (conv.results.conversation) {
                if(!prevConv.results.conversation || prevConv.results.conversation.id !== conv.results.conversation.id || 
                    prevConv.batchNumber >= conv.batchNumber) {
                    newConv = conv;
                } else if (conv.batchNumber > prevConv.batchNumber) {
                    newConv =  {
                        ...conv,
                        results: {
                            ...conv.results,
                            messages: prevConv.results.messages.concat(conv.results.messages)
                        }
                    }
                }
            }

            return {
                ...state,
                isFetchConversationInProgress: false,
                selectedConversation: newConv,
                conversationFetchTime: new Date()
            };
        case FETCH_CONVERSATION_ERROR:
            return {
                ...state,
                isFetchConversationInProgress: false,
                selectedConversation: initialState.selectedConversation
            };

        case FETCH_BLOCKED_USERS_START:
            return {
                ...state,
                isFetchBlockedUsersInProgress: true
            };
        case FETCH_BLOCKED_USERS_SUCCESS:
            return {
                ...state,
                isFetchBlockedUsersInProgress: false,
                blockedUsers: action.payload
            };
        case FETCH_BLOCKED_USERS_ERROR:
            return {
                ...state,
                isFetchBlockedUsersInProgress: false,
                blockedUsers: initialState.blockedUsers
            };
        
        case SEND_MESSAGE_START: 
            return {
                ...state,
                isSendMessageInProgress: true
            }
        case SEND_MESSAGE_SUCCESS: 
            return {
                ...state,
                isSendMessageInProgress: false
            }
        case SEND_MESSAGE_ERROR: 
            return {
                ...state,
                isSendMessageInProgress: false
            }

        case UPDATE_MESSAGE_START:
            return {
                ...state,
                isUpdateMessageInProgress: true
            }
        case UPDATE_MESSAGE_SUCCESS:
            return {
                ...state,
                isUpdateMessageInProgress: false
            }
        case UPDATE_MESSAGE_ERROR:
            return {
                ...state,
                isUpdateMessageInProgress: false
            }

        case FETCH_MEMBERS_IN_SCOPE_START:
            return {
                ...state,
                isFetchMembersInScopeInProgress: true
            }
        case FETCH_MEMBERS_IN_SCOPE_SUCCESS:
            return {
                ...state,
                isFetchMembersInScopeInProgress: false,
                selectedRecipients: action.payload
            }
        case FETCH_MEMBERS_IN_SCOPE_ERROR:
            return {
                ...state,
                isFetchMembersInScopeInProgress: false
            }

        case FETCH_MESSAGE_START:
            return {
                ...state,
                isFetchMessageInProgress: true
            }

        case FETCH_MESSAGE_SUCCESS:
            return {
                ...state,
                isFetchMessageInProgress: false,
                message: action.payload
            }

        case FETCH_MESSAGE_ERROR:
            return {
                ...state,
                isFetchMessageInProgress: false
            }

        case FETCH_REPORT_START:
            return {
                ...state,
                isFetchReportInProgress: true
            }

        case FETCH_REPORT_SUCCESS:
            return {
                ...state,
                isFetchReportInProgress: false,
                report: action.payload
            }

        case FETCH_REPORT_ERROR:
            return {
                ...state,
                isFetchReportInProgress: false
            }

        default:
            return state;
    }
}